import * as React from 'react';
import styled from 'styled-components';

import { Link as LinkT } from '../../../typedefs/store';
import colors from '../../colors';
import Divider from '../../Shared/Divider';
import Link from '../../Shared/Link';

interface Props {
    links: LinkT[];
}

const Links: React.SFC<Props> = ({ links }) => {
    if (links.length === 0) return null;
    return (
        <Wrapper className="conversations-link-list">
            <Divider />
            <Title className="conversations-link-list-title">Need More Information?</Title>
            <P className="conversations-link-list-text">
                Check out the links below for helpful tips and additional details regarding your
                next steps.
            </P>
            {links.slice(0, 5).map((link, i) => (
                <Link key={i} link={link} />
            ))}
        </Wrapper>
    );
};

export default Links;

const Title = styled.h3`color: ${colors.black} !important;`;

const Wrapper = styled.div`margin-bottom: 15px;`;

const P = styled.p`margin: 5px 0 25px 0;`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Cars/Links.tsx